<template>
  <div
    v-if="enableCutouts"
    id="cutouts_container"
    class="matrix_optionsTable matrix_table"
  >
    <div class="matrix_tableHeader">
      {{ $t("Cutouts") }}
    </div>

    <div class="sidebar_popup">
      <div class="cutouts_toolbar">
        <div
          class="cutouts_button btn-primary"
          @click="addNewCutoutHandler('rectangle')"
        >
          <span>{{ $t("Add Rectangle") }}</span>
        </div>
        <div
          class="cutouts_button btn-primary"
          @click="addNewCutoutHandler('circle')"
        >
          <span> {{ $t("Add Circle") }}</span>
        </div>
      </div>
      <ul v-show="total" class="dimensions-list">
        <li
          v-for="(cutoutVar, index) in getCutouts.cutouts"
          :id="'cutout-item-' + index"
          :key="index"
          class="newcutout_item"
        >
          <span class="number">{{ index + 1 }}</span>
          <div :class="'cutout cutout_' + cutoutVar.itemType"></div>
          <div class="posxy">
            <div class="pos_input">
              <label :for="'cutoutX-' + index">{{ $t("X:") }}</label>
              <input
                :id="'cutoutX-' + index"
                v-model.number="cutoutVar.left"
                type="number"
                min="0"
                step="0.1"
                class="cutout_input"
                @keydown.enter="onEnter"
              />
              <span class="cm">{{ $t("cm") }}</span>
            </div>
            <div class="pos_input">
              <label :for="'cutoutY-' + index">{{ $t("Y:") }}</label>
              <input
                :id="'cutoutY-' + index"
                v-model.number="cutoutVar.bottom"
                type="number"
                min="0"
                step="0.1"
                class="cutout_input"
                @keydown.enter="onEnter"
              />
              <span class="cm">{{ $t("cm") }}</span>
            </div>
            <div class="pos_input">
              <label :for="'width-' + index">{{ $t("Width:") }}</label>
              <input
                :id="'width-' + index"
                v-model.number="cutoutVar.width"
                type="number"
                min="0"
                step="0.1"
                class="cutout_input"
                @keydown.enter="onEnter"
              />
              <span class="cm">{{ $t("cm") }}</span>
            </div>
            <div class="pos_input">
              <label :for="'height-' + index">{{ $t("Height:") }}</label>
              <input
                :id="'height-' + index"
                v-model.number="cutoutVar.height"
                type="number"
                min="0"
                step="0.1"
                class="cutout_input"
                @keydown.enter="onEnter"
              />
              <span class="cm">{{ $t("cm") }}</span>
            </div>
          </div>
          <div class="delete-dosen" @click="removeCutoutHandler(index)">
            <appAwesomeIcon icon="trash-alt" useClass="fa fa-trash-o" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { mapState, mapActions } from "pinia";

import * as R from "ramda";

export default {
  data: function () {
    return {
      cutout: {
        left: 0,
        top: 0
      }
    };
  },
  computed: {
    ...mapState(useImageEditorStore, ["getCutouts", "getPOIEVariables"]),
    total: function () {
      return this.getCutouts.cutouts.length;
    },
    cutoutsObjects: function () {
      return this.getCutouts.cutouts;
    },
    enableCutouts: function () {
      return parseFloat(this.getPOIEVariables.enableCutouts);
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, ["addNewCutout", "removeCutout"]),
    onEnter: function (event) {
      event.preventDefault();
    },
    addNewCutoutHandler: function (type) {
      this.addNewCutout({ itemType: type });
    },
    removeCutoutHandler: function (index) {
      this.removeCutout(index);
    }
  },
  watch: {
    cutoutsObjects: {
      handler: function (newData, oldData) {
        R.forEach(function (dosen) {
          dosen["offsetX"] = dosen["width"] / 2;
          dosen["offsetY"] = dosen["height"] / 2;
        }, this.getCutouts.cutouts);
      },
      deep: true
    }
  }
};
</script>
